/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const verificationTypeEnumSchema = z
	.enum(["login", "register", "delete_account"])
	.describe("* `login` - Login\n* `register` - Register\n* `delete_account` - Delete Account");
